import { Component, Input, SimpleChanges } from '@angular/core';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { EPolicyCompany, EPolicyTypes, IBeneficiary } from 'src/app/modules/shared/models/policy.model';
import { CommonUtils } from 'src/app/utils/CommonUtils';
import { PolicyService } from '../../policy.service';
import { isv_policy_beneficiary_keys, policy_beneficiary_keys, policy_beneficiary_keys_PREV, TCM_policy_beneficiary_keys } from './policy-beneficiary.constants';

@Component({
  selector: 'app-policy-beneficiary',
  templateUrl: './policy-beneficiary.component.html',
  styleUrl: './policy-beneficiary.component.scss',
})
export class PolicyBeneficiaryComponent {

  constructor(
    private _policyService: PolicyService
  ) { }

  @Input() list: any[] = [];
  @Input() policyType: EPolicyTypes;

  keys: IObjectKey[] = CommonUtils.assign(null);

  ngOnChanges(changes: SimpleChanges) {
    if (this.isCompanyISV) {
      this.keys = CommonUtils.assign(isv_policy_beneficiary_keys);
    } else {
      switch (this.policyType) {
        case EPolicyTypes.TCM:
        case EPolicyTypes.TCM_PPI:
          this.keys = CommonUtils.assign(TCM_policy_beneficiary_keys);
          break;
        case EPolicyTypes.PREVIDENZIALI:
          this.keys = CommonUtils.assign(policy_beneficiary_keys_PREV);
          break
        default:
          this.keys = CommonUtils.assign(policy_beneficiary_keys);
          break;
      }
    }
  }

  getPlaceholders(keysLength: number): number[] {
    const array = CommonUtils.getPlaceholders(keysLength, 4);
    return array;
  }

  getBeneficiaryDescription(item: IBeneficiary): string {
    if (item) {
      return item.codeChoice === 'Beneficiario Testo Libero'
        ? item.descBeneficiary
        : item.name && item.surname && item.taxCode
          ? `${item.name} ${item.surname} (${item.taxCode})`
          : item.codeChoice;
    }
  }

  get company(): string {
    return this._policyService.companyId;
  }

  get isCompanyISV(): boolean {
    return this._policyService.companyId === EPolicyCompany.ISV;
  }

}
